export default "__VITE_ASSET__Dvyddd7h__"